import WorksList from '../../models/works/WorksList'
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async"
import { qs, qsAll, ISOvserve, removeClass, addClass, loaded, loading, ISOvserver } from "modules/modules"
import { useMemo } from 'react';
import useBackground from '../../../hooks/useBackground'
import PrimaryHeading from 'components/headings/PrimaryHeading'
import { useEffect, useState } from 'react';

type Props = {
}

export default function Index(props: Props) {

  const background = useBackground();

  // アニメーション用
  useEffect(() => {
    let observer: IntersectionObserver;
    observer = ISOvserver();
    return () => {
      observer.disconnect();
    };
  }, []);

  const index = useMemo(() => {
    return (
      <>
        <Helmet>
          <title>WORKS｜WiLDCARD Inc.</title>
          <meta name="description" content="制作実績一覧｜映像制作の「万能の手札」。アーティストライブ映像、TVCMの映像制作を手掛ける映像制作会社、株式会社WiLDCARD。アニメーション、VFX、3DCGなど幅広い映像に対応。映像制作に関するご相談、お待ちしております。" />
          <meta property="og:url" content="https://wildcard.jp/works" />
          <meta property="og:title" content="WORKS｜WiLDCARD Inc." />
        </Helmet>
        <motion.div
          initial={{ opacity: 0 }} // このページに遷移した直後
          animate={{ opacity: 1 }} // 最終的な状態
          exit={{ opacity: 0 }} // 離れる際にどうなるか
          transition={{ duration: 0.5 }} // 切り替えに要する時間
        >

          <main id="p__works_index" className="l__content_width">
            <PrimaryHeading letter="WORKS" letter_ja="制作実績" />
            <WorksList limit={12} pagenate={true} category={true} />
          </main>
        </motion.div>
      </>
    );
  }, [])

  return (
    <>
      {index}
    </>
  );

}